export const quad = (timeFraction: number, n = 2) => Math.pow(timeFraction, n);
